"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importStar(require("../../styled"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var button_1 = __importDefault(require("../../atoms/button"));
var tokens_1 = require("../../tokens");
var ButtonGroup = function (props) { return (React.createElement(ButtonGroup.Element, __assign({}, props, automation_attribute_1.default('button-group')), React.Children.map(props.children, function (child, index) {
    if (child) {
        return (React.createElement(ButtonGroup.Child, { key: index, first: index === 0, last: index === React.Children.count(props.children) - 1, compressed: props.compressed }, child));
    }
    return null;
}))); };
var firstButtonStyles = styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n"], ["\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n"])));
var lastButtonStyles = styled_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n"], ["\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n"])));
var middleButtonStyles = styled_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-radius: 0;\n"], ["\n  border-radius: 0;\n"])));
ButtonGroup.Child = styled_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", " {\n    ", ";\n    ", ";\n    ", ";\n  }\n"], ["\n  ", " {\n    ", ";\n    ", ";\n    ", ";\n  }\n"])), button_1.default.Element, function (props) { return (props.compressed && props.first ? firstButtonStyles : null); }, function (props) { return (props.compressed && props.last ? lastButtonStyles : null); }, function (props) { return (props.compressed && !props.first && !props.last ? middleButtonStyles : null); });
var justifyContent = {
    left: 'flex-start',
    right: 'flex-end'
};
var marginForButton = function (props) {
    if (!props.children) {
        return '';
    }
    var isSingleChild = props.children.constructor.name !== 'Array';
    if (isSingleChild || props.compressed) {
        return null;
    }
    var property = props.align === 'left' ? 'margin-right' : 'margin-left';
    var trailing = props.align === 'left' ? '&:last-child' : '&:first-child';
    return "\n  " + property + ": " + tokens_1.spacing.xsmall + ";\n\n  " + trailing + " {\n    " + property + ": 0;\n  }\n  ";
};
ButtonGroup.Element = styled_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  justify-content: ", ";\n\n  & > * {\n    ", ";\n  }\n"], ["\n  display: flex;\n  justify-content: ", ";\n\n  & > * {\n    ", ";\n  }\n"])), function (props) { return justifyContent[props.align]; }, marginForButton);
var StyledButtonGroup = ButtonGroup.Element;
exports.StyledButtonGroup = StyledButtonGroup;
ButtonGroup.defaultProps = {
    compressed: false,
    align: 'left'
};
exports.default = ButtonGroup;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=button-group.js.map